import { Dialog } from '@factorialco/f0-react/dist/experimental'
import { EngagementUnscheduleSurveyDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  surveyId: string
  onCancel?: () => void
  onSuccess?: () => void
}

export function UnscheduleSurveyDialog({ surveyId, onCancel, onSuccess }: Props) {
  const [unscheduleSurvey] = useMutation(EngagementUnscheduleSurveyDocument, {
    extractorFn: (data) => data.surveysMutations.unscheduleSurveysSurvey,
  })

  return (
    <Dialog
      open
      onClose={onCancel}
      header={{
        title: i18n.t('surveys.unschedule_survey_dialog.title'),
        description: i18n.t('surveys.unschedule_survey_dialog.description'),
        type: 'critical',
      }}
      actions={{
        primary: {
          label: i18n.t('surveys.unschedule_survey_dialog.unschedule'),
          variant: 'critical',
          onClick: async () => {
            const response = await unscheduleSurvey({
              variables: {
                surveyId,
              },
            })

            const handled = handleResult(response, () => {})

            if (handled.success) {
              onSuccess?.()
            }
          },
        },
        secondary: {
          label: i18n.t('common.cancel'),
          onClick: () => onCancel?.(),
        },
      }}
    />
  )
}
